import { Injectable, Inject, InjectionToken } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { v4 as uuid } from 'uuid';

export const SWIMLANE = new InjectionToken<string>('swimlane');

/**
 * This interceptor adds a X-ContextId header to all requests
 * helpful when debugging and identifiying traffic to our APIs
 */
@Injectable()
export class HttpSwimlaneInterceptor implements HttpInterceptor {
  constructor(@Inject(SWIMLANE) public swimlane: string) {}

  /**
   * Intercepter that will memoize HTTP requests and store the results
   * @param req - the http request being executed
   * @param next - the next step in the http chain
   */
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    // strip white space and hyphen from guid
    const id = uuid().replace(/-|\s/g, '');

    // Clone the request and replace the original headers with
    // cloned headers, updated with a X-ContextId.
    const authReq = req.clone({
      headers: req.headers.set('X-ContextId', `${id},${this.swimlane}`),
    });

    // send cloned request with header to the next handler.
    return next.handle(authReq);
  }
}
